import SendNotificationButton from '@/components/Projects/NextStepProject.vue';
import NotificationsClickSignService from "@/services/server/NotificationsClicksignService";
import {showErrorSnackBar, showSuccessSnackBar} from "@/utils/SnackBartHelper";


export default {
    name: "NotificationsTab",
    components: {
        SendNotificationButton
    },
    data: () => ({
        isLoadingNotificationBtn: false,
        isLoadingSingleNotificationBtn: false,
        headers: [
            {text: 'Nome do Signatário', value: 'attributes.name'},
            {text: 'Ação', value: 'actions'},
        ],
        signers: [],
    }),
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        param: {
            type: Array,
            default: () => ([])
        },
        idEnvelope: {
            type: String,
            default: null,
        },
        envelopeStatus: {
            type: String,
            default: null,
        },
    },
    methods: {
        getFirstAndLastNames(fullName) {
            const names = fullName.trim().split(/\s+/);
            const firstName = names[0]
            const lastName = names[names.length - 1]

            const capitalize = name => name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()

            return `${capitalize(firstName)} ${capitalize(lastName)}`
        },
        async sendSignerNotification(item) {
            try {
                this.isLoadingSingleNotificationBtn = true
                const result = await NotificationsClickSignService.notifySigner(this.idEnvelope, item.id);

                if (result.data.data.data.id) {
                    showSuccessSnackBar(`Notificação Enviada com sucesso para ${this.getFirstAndLastNames(item.attributes.name)}!`)
                } else {
                    showErrorSnackBar("Ocorreu um erro inesperado, contacte o suporte!")
                }

            } catch (error) {
                this.isLoadingSingleNotificationBtn = false
                console.error("error", error);
            } finally {
                this.isLoadingSingleNotificationBtn = false
            }
        },
        async sendAllNotifications() {
            try {
                this.isLoadingNotificationBtn = true
                const result = await NotificationsClickSignService.notifyAllSigners(this.idEnvelope);

                if (result.data.data.data.id) {
                    showSuccessSnackBar("Notificações Enviadas com sucesso!")
                } else {
                    showErrorSnackBar("Ocorreu um erro inesperado, contacte o suporte!")
                }

            } catch (error) {
                this.isLoadingNotificationBtn = false
                console.error("error", error);
            } finally {
                this.isLoadingNotificationBtn = false
            }
        }
    },
    watch: {
        param: {
            deep: true,
            immediate: true,
            handler(newValue) {
                this.signers = newValue
            }
        },
    }
}